import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface AnneeScolaire {
  _id: string;
  label: string;
  isCurrent: boolean;
  date_debut?: string;
  date_fin?: string;
}

export const anneeScolaireSlice = createApi({
  reducerPath: "AnneeScolaire",
  baseQuery: baseQueryWithAuth("annee-scolaire"),
  tagTypes: ["AnneeScolaire"],
  endpoints(builder) {
    return {
      fetchAnneeScolaires: builder.query<AnneeScolaire[], void>({
        query: () => "/",
        providesTags: ["AnneeScolaire"],
      }),
      fetchCurrentAnneeScolaire: builder.query<AnneeScolaire, void>({
        query: () => "/current",
        providesTags: ["AnneeScolaire"],
      }),
      createAnneeScolaire: builder.mutation<AnneeScolaire, Partial<AnneeScolaire>>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body,
        }),
        invalidatesTags: ["AnneeScolaire"],
      }),
      updateAnneeScolaire: builder.mutation<AnneeScolaire, Partial<AnneeScolaire>>({
        query: ({ _id, ...rest }) => ({
          url: `/${_id}`,
          method: "PATCH",
          body: rest,
        }),
        invalidatesTags: ["AnneeScolaire"],
      }),
      deleteAnneeScolaire: builder.mutation<void, string>({
        query: (id) => ({
          url: `/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AnneeScolaire"],
      }),
      setCurrentAnneeScolaire: builder.mutation<AnneeScolaire, string>({
        query: (id) => ({
          url: `/${id}/set-current`,
          method: "POST",
        }),
        invalidatesTags: ["AnneeScolaire"],
      }),
      cloturerAnneeScolaire: builder.mutation<any, { nouvelle_annee: string }>({
        query: (body) => ({
          url: "/cloturer",
          method: "POST",
          body,
        }),
        invalidatesTags: ["AnneeScolaire"],
      }),
      migrateAnneeScolaire: builder.mutation<any, void>({
        query: () => ({
          url: "/migrate",
          method: "POST",
        }),
      }),
    };
  },
});

export const {
  useFetchAnneeScolairesQuery,
  useFetchCurrentAnneeScolaireQuery,
  useCreateAnneeScolaireMutation,
  useUpdateAnneeScolaireMutation,
  useDeleteAnneeScolaireMutation,
  useSetCurrentAnneeScolaireMutation,
  useCloturerAnneeScolaireMutation,
  useMigrateAnneeScolaireMutation,
} = anneeScolaireSlice;
